import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import {InputTextCustom} from '../../../src/App'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
      flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['+', /[3]/, /[8]/,'(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', '-', ' ', /\d/, /\d/,' ', '-', ' ', /\d/, /\d/]}

      showMask={false}
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired
};

export default function FormattedInputs(props) {
  const classes = useStyles();

  const [labelWidth, setLabelWidth] = React.useState(0);
  const labelRef = React.useRef(null);
  React.useEffect(() => {
    setLabelWidth(labelRef.current.offsetWidth);
  }, []);
  

  return (
    <div>
      <FormControl error={props.error} className={classes.formControl} variant={props.variant}>
        <InputLabel
        className={props.classNamelabel}
         ref={labelRef} htmlFor="component-outlined">
                     {props.label}
                    </InputLabel>
        <InputTextCustom
          error={props.error}
          name ={props.name}
          required={props.required}
          value={props.value}
          inputVariant="outlined"
          className={props.className}
          onChange={props.handleChange}
          id={props.id}
          margin={props.margin}
          inputComponent={TextMaskCustom}
          labelWidth={labelWidth}
          disabled={props.disabled}
        />
      </FormControl>
    </div>
  );
}